export default __webpack_public_path__ + "static/media/idle.f8e80e30.jpg";